import { useQuery } from '@tanstack/react-query';

import { fetchUpdateStatus, type UpdateStatus } from '../api/updateCheckApi';

/**
 * Статус доступности новой версии Hub (#112).
 *
 * Один общий queryKey на футер и баннер: react-query дедуплицирует запрос, и
 * оба потребителя читают один ответ вместо двух round-trip'ов на каждый рендер
 * страницы.
 *
 * `retry: false` — эндпоинт admin-only, и для не-админа он отвечает 403. Ретраи
 * превратили бы штатный отказ в поток запросов на каждой загрузке страницы у
 * каждого рядового пользователя.
 */
export function useUpdateStatus() {
  return useQuery<UpdateStatus>({
    queryKey: ['update-status'],
    queryFn: fetchUpdateStatus,
    retry: false,
    // Проверка на backend'е идёт раз в сутки — опрашивать её чаще, чем раз в
    // час, значит гонять запрос ради значения, которое не изменилось.
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
